<template>
  <div>
    <div class="form-group">
      <label class="title6-5">Name <span>*</span> </label>
      <input
          id="FullName"
          v-model="fullName"
          v-validate="'required|min:2'"
          class="form-control"
          name="fullName"
          type="text"
      />
    </div>
    <div class="form-group">
      <label class="title6-5">Email <span>*</span> </label>
      <input
          id="EmailAddress"
          v-model="editModel.Email"
          v-validate="'required|email'"
          class="form-control"
          name="email"
          type="text"
      />
    </div>
    <div class="form-group">
      <label class="title6-5">Phone <span>*</span> </label>
      <input
          id="Phone Number"
          v-model="editModel.Phone"
          v-validate="{ required: true, min: 8, regex: this.getRegex(), max: this.getMax()}"
          class="form-control"
          name="phoneNumber"
          type="text"
      />
    </div>

    <slot></slot>
    <div >
<!--      <div class="form-control rounded-lg d-flex container align-items-center">-->
<!--        <img alt="credit card icon"-->
<!--             src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2aRmDMi-T1Y3dqZER8z-_vjqfsxgmQEoEww&usqp=CAU"-->
<!--             style="width: 22px; height: 17px; margin-right: 4px"/>-->
<!--        <input-->
<!--            id="frmCCNum"-->
<!--            v-model="cardModel.CardNumber"-->
<!--            v-mask="'#### #### #### ####'"-->
<!--            v-validate="paymentMethod == 1 ? 'required|credit_card|CardNumberValidation' : ''"-->
<!--            autocomplete="cc-number"-->
<!--            class="border-0"-->
<!--            maxlength="19"-->
<!--            name="cardNumber"-->
<!--            placeholder="1234 1234 1234 1234"-->
<!--            style="width: 80%; outline: none; font-size: 16px !important; "-->
<!--            type="text"/>-->

<!--        <input-->

<!--            id="frmCCExp"-->
<!--            v-mask="'##/##'"-->
<!--            v-model.trim="cardModel.ExpireDate"-->
<!--            v-validate="paymentMethod == 1 ? { required: true, CartValidation:12 } : ''"-->
<!--            autocomplete="cc-exp"-->
<!--            class="border-0"-->
<!--            name="expiryDate"-->
<!--            placeholder="MM/YY"-->
<!--            style="width: 30%; outline: none; font-size: 16px !important;"-->
<!--            type="text"-->

<!--        />-->

<!--        <input-->

<!--            id="frmCCCVC"-->
<!--            v-model="cardModel.CVV"-->
<!--            v-mask="['####']"-->
<!--            v-validate="paymentMethod == 1 ? { required: true, regex: /^[0-9]{3,4}$/ } : ''"-->
<!--            autocomplete="cc-csc"-->
<!--            class="border-0"-->
<!--            name="CVV"-->
<!--            placeholder="111"-->
<!--            style="width: 20%; outline: none; font-size: 16px !important;"-->
<!--            type="text"/>-->
<!--      </div>-->
      <div class="w-100">
        <div class="card-input" id="giftcard-element"></div>

        <div v-if="error" style="paddingTop: 8px; color: red; font-size: 12px" id="card-error">
          {{error}}
        </div>

      </div>

    </div>

  <!-- <div class="form-check mt-2">
    <input
      class="form-check-input"
      type="checkbox"
      value=""
      id="flexCheckDefault"
    />
    <label class="form-check-label title6-5" for="flexCheckDefault">
      Save card for next time
    </label>
  </div> -->
</div>
</template>
<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
export default {
  name: "CheckoutComponent",
  directives: { mask },

  props: {
    editModel: {
      type: Object,
      default: () => {}
    },
    cardModel: {
      type: Object,
      default: () => {}
    },
    storeid: {
      type: String,
      default: ""
    },
    paymentMethod: {
      type: Number,
      default: 1
    },
    bus: {
        type: Object,
        default: () => {}
    },
  },
  data() {
    return {
      stripe: null,
      clientSecret: "",
      token: null,
      cardElement: null,
      error: ''
    };
  },
  mounted() {
    this.cardElement = this.stripeElements.create('card', {
      hidePostalCode: true
    });

    this.cardElement.mount('#giftcard-element');

  },
  computed: {
    ...mapGetters(["giftCartItems", "giftDiscount", "selectedCompany"]),
    fullName: {
      get() {
        if (!this.editModel) {
          return ""
        }
        const {FirstName, LastName} = this.editModel
        if (!LastName.length) {
          return FirstName
        }
        return FirstName + " " + LastName
      },
      set(val) {
        if (!val) return
        const [firstName, ...lastName] = val.split(' ').filter(Boolean);
        this.editModel.FirstName = firstName;
        this.editModel.LastName = lastName.join(' ');
      }
    },
    stripeElements () {
      return this.$stripe.elements();
    }
  },
  created() {
      var that = this;
      this.bus.$on('validateCheckOutInfo', () => {
          that.$validator.validate().then(valid => {
              if (!valid) {
                  that.$emit("checkOutValidation", false);
              }
              else
              {
                  that.$emit("checkOutValidation", true);
              }
          });
      });
  },
  methods: {
    getMax(){
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? 10:15
    },
    getRegex(){
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? /04\d{8}/:/\d/
    },
    validate() {
      return this.$validator.validateAll();
    },
    getCardElement() {
      return this.cardElement
    },
  }
}
</script>


<style lang="scss" scoped>
.card-vaidation {
.invalid-feedback {
  display: block;
}
}

.cardImg{
  width: 27px;
  height: 20px;
  margin-right: 4px;
}

.card-input {
  padding: 10px;
  width: 100%;
  border: 1px solid #ced4da;
}

</style>
